import { toaster } from 'components/design-system/Toaster';

export const onlyCardPayment = ['CARD'];
export const showPaymentToastError = () => toaster.error('Payment failed. Please try again later');
